<template>
  <div class="wrap" v-if="showWrap" :class="showContent ?'fadein':'fadeout'" :style="style1">{{text}}</div>
</template>
<script>
import global from '../../components/global'

export default {

  data () {
    return {
      fontsize: global.fontsize
    }
  },
  computed: {
    style1: function () {
      const style = 'font-size:' + (this.fontsize + 5) + 'px'
      return style
    }
  }
}
</script>
<style scoped>
  .wrap{
    position: fixed;
    left: 35%;
    top:30%;
    background: rgba(0,0,0,.95);
    padding: 10px;
    border-radius: 5px;
    transform: translate(-50%,-50%);
    color:#fff;
    font-size: 55px;
  }
  .fadein {
    animation: animate_in 0.25s;
  }
  .fadeout {
    animation: animate_out 0.25s;
    opacity: 0;
  }
  @keyframes animate_in {
    0% {
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  }
  @keyframes animate_out {
    0% {
      opacity: 1;
    }
    100%{
      opacity: 0;
    }
  }
</style>
